module.exports = __webpack_public_path__ + "static/slider-4-1852f75e69dc3919dcedec48cd804797.png";